module.exports = __webpack_public_path__ + "img/bgserviciosmobile-v2.58bbad3d.jpg";